import React, { FC } from 'react';
import { FiltersProvider } from './FiltersProvider';
import styles from './search_filters_selected.module.scss';
import { FilterType } from './FilterItem';
import { Carousel } from '../../../../../components/carousel/Carousel';
import { FiltersList } from './FiltersList';
import { SearchExceptExpressions } from '../../../except-expressions/SearchExceptExpressions';
import { ResultsType } from '../../../../state/reducers/results.types';

type Props = {
  exceptExpressions: ResultsType['exceptExpressions'];
};

export const SearchFiltersSelected: FC<Props> = ({
  exceptExpressions = [],
}) => {
  return (
    <FiltersProvider>
      {(filters: Array<FilterType>) => {
        if (!filters.length && !exceptExpressions.length) {
          return null;
        }
        return (
          <div className={styles.container}>
            <Carousel>
              {(resetScroll) => (
                <>
                  <SearchExceptExpressions
                    exceptExpressions={exceptExpressions}
                    onExpressionsUpdate={resetScroll}
                  />
                  <FiltersList
                    filters={filters}
                    onFiltersUpdate={resetScroll}
                  />
                </>
              )}
            </Carousel>
          </div>
        );
      }}
    </FiltersProvider>
  );
};
